export default "__VITE_ASSET__9XB4maEY__"